import { render, staticRenderFns } from "./DisableAdvancedModeConfirm.vue?vue&type=template&id=f8ad0fce&scoped=true&"
import script from "./DisableAdvancedModeConfirm.vue?vue&type=script&lang=ts&"
export * from "./DisableAdvancedModeConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ad0fce",
  null
  
)

export default component.exports